import Cookie from 'react-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';

class ResultLinks extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showManage: false,
    };
  }

  watchThisSearch(e) {
    $(window).trigger('watchThisSearch.open');
    e.preventDefault();
    setTimeout(() => {
      document.getElementById("modal-close").focus();
    }, 100);
  }

  manageWatchedSearches(e){
    $(window).trigger('manageWatchedSearches.open');
    e.preventDefault();
  }

  componentDidMount() {
    var email = Cookie.load('userEmail');
    if (email && email.length > 0) {
      this.setState({showManage: true});
    }
  }

  render() {
    var manage = this.state.showManage ? (
      <a href="#" onClick={this.manageWatchedSearches} className="until-xs">
        Manage <span className="until-sm">watched</span> searches &nbsp;
      </a>
    ) : null;
    return (
      <div>
        {manage}
        <button onClick={this.watchThisSearch} className="highlight-black">
          Watch <span className="until-xs">this</span> search
        </button>
      </div>
    );
  }
}

ResultLinks.propTypes = {
  regionUrl: PropTypes.string.isRequired
}

export default ResultLinks;


// WEBPACK FOOTER //
// ./src/components/search/result-links.jsx